import { take, put } from "redux-saga/effects";
import { legit } from "apex-legit-service";
import { PayloadAction, TypeConstant } from "typesafe-actions";
import { fetchLegacyUrl } from "services/legit/legacyUrl";
import { ApexApiError } from "../../types";

export function* appFlow() {
  while (true) {
    const action: PayloadAction<TypeConstant, ApexApiError> = yield take([
      fetchLegacyUrl.failure,
    ]);
    if (!action) {
      continue;
    }

    // try to get the status code
    let statusCode = action.payload.status;
    if (!statusCode && action.payload.response) {
      statusCode = action.payload.response.status;
    }

    // If request failed with unauthorized status, present login ui.
    if (statusCode === 401) {
      yield put(legit.showLoginUI(legit.LOGIN_UI_SHOW));
    }
  }
}

export default [appFlow()];
